import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap/lib'
import { Switch, Route } from 'react-router-dom'
import User from './Global/Modules/User'
import Api from './Global/Modules/Api'
import { Redirect } from 'react-router-dom'
//MODULES
import Logo from './Global/Modules/Logo'
import Topmenu from './Global/Modules/Topmenu'
import Mainmenu from './Global/Modules/Mainmenu'
import Sidebar from './Global/Modules/Sidebar'
import FooterData from './Global/Modules/FooterData'
import FooterCounters from './Global/Modules/FooterCounters'

//ROUTES
import Organisatie from './Public/Pages/Organisatie'
import Toelatingseisen from './Public/Pages/Toelatingseisen'
import Rcrort from './Public/Pages/Rc-ro-rt-worden'
import Gedragscode from './Public/Pages/Gedragscode'
import Constructeurs from './Public/Pages/Constructeurs'
import Opdrachtgevers from './Public/Pages/Opdrachtgevers'
import Account from './Public/Pages/Account'
import Contact from './Public/Pages/Contact'
import Reglamenten from './Public/Pages/Reglamenten'
import Cursusinformatie from './Public/Pages/Cursus-informatie'
import Evenementenkalender from './Public/Pages/Evenementen-kalender'
import Bedrijven from './Public/Pages/Bedrijven'
import Controleren from './Public/Pages/Controleren'
import Mededelingen from './Public/Pages/Mededelingen'
import Mededeling from './Public/Pages/Mededeling'
import RaportExample from './Public/Pages/RaportExample'
//ROUTES MEMBER

import MijnCR from './Member/Pages/MijnCR'
import AccountBeheren from './Member/Pages/AccountBeheren'
import WachtwoordWijzigen from './Member/Pages/WachtwoordWijzigen'
import AccountIndienen from './Member/Pages/AccountIndienen'
import OpleidingBeheren from './Member/Pages/OpleidingBeheren'
import RapportBekijken from './Member/Pages/RapportBekijken'
import WerkervaringBeheren from './Member/Pages/Werkervaring/WerkervaringBeheren'
import WerkervaringReferenties from './Member/Pages/Werkervaring/WerkervaringReferenties'
import WerkervaringReferentiesControle from './Member/Pages/Werkervaring/WerkervaringControle'
import WerkervaringReferentieEmail from './Member/Pages/Werkervaring/WerkervaringReferentieEmail'
import WerkervaringReferentieDetail from './Member/Pages/Werkervaring/WerkervaringReferentieDetail'
import WerkervaringWijzig from './Member/Pages/Werkervaring/Edit'

import MemberCursusAdd from './Member/Pages/Toevoegen/Cursus'
import MemberCursusOnbekendAdd from './Member/Pages/Toevoegen/CursusOnbekend'
import MemberOpleidingAdd from './Member/Pages/Toevoegen/Opleiding'
import MemberOpleidingOnbekendAdd from './Member/Pages/Toevoegen/OpleidingOnbekend'
import MemberIncompanyCursusAdd from './Member/Pages/Toevoegen/IncompanyCursus'
import MemberIncompanyKennisAdd from './Member/Pages/Toevoegen/IncompanyKennisoverdracht'
import MemberPublicatiesAdd from './Member/Pages/Toevoegen/Publicatie'
import MemberVoordrachtAdd from './Member/Pages/Toevoegen/Voordracht'

import MemberDocentschapOverviewAdd from './Member/Pages/Toevoegen/Docentschap'
import MemberDocentschapAddDocentschap from './Member/Pages/Toevoegen/DocentschapAdd'
import MemberDocentschapAddAfstudeerbegeleiding from './Member/Pages/Toevoegen/AfstudeerBegeleidingAdd'
import MemberDocentschapAddGastcollege from './Member/Pages/Toevoegen/GastCollegeAdd'
import MemberDocentschapAddExaminator from './Member/Pages/Toevoegen/ExaminatorAdd'

import MemberLidmaatschapOverviewAdd from './Member/Pages/Toevoegen/Lidmaatschap'
import MemberLidmaatschapAddBestuurslid from './Member/Pages/Toevoegen/BestuurslidAdd'
import MemberLidmaatschapAddRedactielid from './Member/Pages/Toevoegen/RedactielidAdd'
import MemberLidmaatschapAddComissielid from './Member/Pages/Toevoegen/ComissielidAdd'
import MemberLidmaatschapAddLidstudiecel from './Member/Pages/Toevoegen/LidstudiecelAdd'

import MemberBijeenkomstAdd from './Member/Pages/Toevoegen/Bijeenkomst'
import MemberBijeenkomstOnbekendAdd from './Member/Pages/Toevoegen/BijeenkomstOnbekend'


//ROUTES ADMIN
import AdminIndex from './Admin/Pages/Index'

import MededelingOverview from './Admin/Pages/Mededelingen/Overview';
import MededelingAdd from './Admin/Pages/Mededelingen/Add';
import MededelingEdit from './Admin/Pages/Mededelingen/Edit';

import AccountsOverview from './Admin/Pages/Accounts/Overview';
import AccountsAdd from './Admin/Pages/Accounts/Add';
import AccountsEdit from './Admin/Pages/Accounts/Edit';

import BedrijvenOverview from './Admin/Pages/Bedrijven/Overview';
import BedrijvenEdit from './Admin/Pages/Bedrijven/Edit';
import BedrijvenAdd from './Admin/Pages/Bedrijven/Add';

import ContentOverview from './Admin/Pages/Content/Overview';
import ContentEdit from './Admin/Pages/Content/Edit'

import GroepenOverview from './Admin/Pages/Groepen/Overview';
import GroepenAdd from './Admin/Pages/Groepen/Add';
import GroepenEdit from './Admin/Pages/Groepen/Edit';

import KennisOverview from './Admin/Pages/Kennis/Overview';

import KennisAdd from './Admin/Pages/Kennis/Add/KennisAdd';
import OpleidingAdd from './Admin/Pages/Kennis/Add/OpleidingAdd';
import BijeenkomstAdd from './Admin/Pages/Kennis/Add/BijeenkomstAdd';
import CursusAdd from './Admin/Pages/Kennis/Add/CursusAdd';
import DocentschapChooseAdd from './Admin/Pages/Kennis/Add/DocentschapChooseAdd';
import DocentschapAdd from './Admin/Pages/Kennis/Add/DocentschapAdd'
import IncompanyAdd from './Admin/Pages/Kennis/Add/IncompanyAdd';
import LidmaatschapAdd from './Admin/Pages/Kennis/Add/LidmaatschapAdd';
import LidmaatschapChooseAdd from './Admin/Pages/Kennis/Add/LidmaatschapChooseAdd';
import PublicatiesAdd from './Admin/Pages/Kennis/Add/PublicatiesAdd';
import VoordrachtAdd from './Admin/Pages/Kennis/Add/VoordrachtAdd';

import AdminMemberCursusAdd from './Admin/Pages/Leden/Lid/Toevoegen/Cursus'
import AdminMemberCursusOnbekendAdd from './Admin/Pages/Leden/Lid/Toevoegen/CursusOnbekend'
import AdminMemberOpleidingAdd from './Admin/Pages/Leden/Lid/Toevoegen/Opleiding'
import AdminMemberOpleidingOnbekendAdd from './Admin/Pages/Leden/Lid/Toevoegen/OpleidingOnbekend'
import AdminMemberIncompanyCursusAdd from './Admin/Pages/Leden/Lid/Toevoegen/IncompanyCursus'
import AdminMemberIncompanyKennisAdd from './Admin/Pages/Leden/Lid/Toevoegen/IncompanyKennisoverdracht'
import AdminMemberPublicatiesAdd from './Admin/Pages/Leden/Lid/Toevoegen/Publicatie'
import AdminMemberVoordrachtAdd from './Admin/Pages/Leden/Lid/Toevoegen/Voordracht'

import AdminMemberDocentschapOverviewAdd from './Admin/Pages/Leden/Lid/Toevoegen/Docentschap'
import AdminMemberDocentschapAddDocentschap from './Admin/Pages/Leden/Lid/Toevoegen/DocentschapAdd'
import AdminMemberDocentschapAddAfstudeerbegeleiding from './Admin/Pages/Leden/Lid/Toevoegen/AfstudeerBegeleidingAdd'
import AdminMemberDocentschapAddGastcollege from './Admin/Pages/Leden/Lid/Toevoegen/GastCollegeAdd'
import AdminMemberDocentschapAddExaminator from './Admin/Pages/Leden/Lid/Toevoegen/ExaminatorAdd'

import AdminMemberLidmaatschapOverviewAdd from './Admin/Pages/Leden/Lid/Toevoegen/Lidmaatschap'
import AdminMemberLidmaatschapAddBestuurslid from './Admin/Pages/Leden/Lid/Toevoegen/BestuurslidAdd'
import AdminMemberLidmaatschapAddRedactielid from './Admin/Pages/Leden/Lid/Toevoegen/RedactielidAdd'
import AdminMemberLidmaatschapAddComissielid from './Admin/Pages/Leden/Lid/Toevoegen/ComissielidAdd'
import AdminMemberLidmaatschapAddLidstudiecel from './Admin/Pages/Leden/Lid/Toevoegen/LidstudiecelAdd'

import AdminMemberBijeenkomstAdd from './Admin/Pages/Leden/Lid/Toevoegen/Bijeenkomst'
import AdminMemberBijeenkomstOnbekendAdd from './Admin/Pages/Leden/Lid/Toevoegen/BijeenkomstOnbekend'


import OpleidingOverview from './Admin/Pages/Kennis/Overviews/OverviewOpleiding';
import BijeenkomstOverview from './Admin/Pages/Kennis/Overviews/OverviewBijeenkomst';
import CursusOverview from './Admin/Pages/Kennis/Overviews/OverviewCursus';
import DocentschapOverview from './Admin/Pages/Kennis/Overviews/OverviewDocentschap';
import IncompanyOverview from './Admin/Pages/Kennis/Overviews/OverviewIncompany';
import LidmaatschapOverview from './Admin/Pages/Kennis/Overviews/OverviewLidmaatschap';
import PublicatiesOverview from './Admin/Pages/Kennis/Overviews/OverviewPublicaties';
import VoordrachtOverview from './Admin/Pages/Kennis/Overviews/OverviewVoordracht';

import LedenOverview from './Admin/Pages/Leden/Overview';
import LidGegevens from './Admin/Pages/Leden/Lid/Gegevens';
import LidBedrijf from './Admin/Pages/Leden/Lid/Bedrijf';
import LidKennis from './Admin/Pages/Leden/Lid/Kennis';
import ChangePasswordAdmin from './Admin/Modules/Leden/Lid/WachtwoordWijzigen';
import LidWerkervaring from './Admin/Pages/Leden/Lid/Werkervaring';
import LidPermanenteKennis from './Admin/Pages/Leden/Lid/PermanenteKennis';
import LidDoorlopendeWerkervaring from './Admin/Pages/Leden/Lid/DoorlopendeWerkervaring';
import LidBeoordelingsDocumenten from './Admin/Pages/Leden/Lid/BeoordelingsDocumenten';
import LidBeoordelingsDocumentenAdd from './Admin/Pages/Leden/Lid/BeoordelingsDocumentAdd';
import LidBeoordelingsDocumentenEdit from './Admin/Pages/Leden/Lid/BeoordelingsDocumentEdit';
import LidVerklaringen from './Admin/Pages/Leden/Lid/Verklaringen';
import LidKennisOmzetten from './Admin/Pages/Leden/Lid/KennisOmzetten';
import LidInloggen from './Admin/Pages/Leden/Lid/Inloggen';
import LidAdd from './Admin/Pages/Leden/Add';

import LogsOverview from './Admin/Pages/Logs/Overview';
import RegistratiesOverview from './Admin/Pages/Registraties/Overview';
import RoO2Overview from './Admin/Pages/RoO2/Overview';


//ROUTES NOT FOUND
import NotFound from './NotFound/NotFound'
import Home from './Public/Pages/Home';


const PrivateRoute = ({ component: Component, ...rest }) => (
	<Route {...rest} render={(props) => (
		User.hasMemberRole() === true
			? <Component {...props} />
			: <Redirect to='/account' />
	)} />
)
const PrivateAdminRoute = ({ component: Component, ...rest }) => (
	<Route {...rest} render={(props) => (
		User.isAdmin() === true
			? <Component {...props} />
			: <Redirect to='/account' />
	)} />
)

class App extends Component {
	constructor() {
		super();
		this.state = {
			Button: '',
			ShowSideBar: '',
			bodyContentXS: '',
			bodyContentMD: '',
			publicUrls: ["/", "/info/organisatie", "/rapport/voorbeeld", "/info/toelatingseisen", "/info/rcro", "/info/beroepseed", "/info/voor-constructeurs", "/info/voor-opdrachtgevers", "/account", "/info/contact", "/cursusinformatie", "/evenementenkalender", "/bedrijven", "/controleren", "/nieuws", "/info/reglamenten"]
		}
		this.setParentButton = this.setParentButton.bind(this);
	}

	// setAccountMenu(event) {
	//   this.setState({ show: true });
	// }

	setParentButton(btn) {
		this.setState({ Button: btn });
	}
	componentDidMount() {
		if (Api.isLoggedIn() && window.location.pathname.indexOf("/controleren/") === -1 && window.location.pathname.indexOf("/nieuws/nieuws-item/") === -1 && this.state.publicUrls.indexOf(window.location.pathname) === -1) {
			this.setState({ ShowSideBar: "hide" })
			this.setState({ bodyContentXS: 12 })
			this.setState({ bodyContentMD: 12 })
		} else {
			this.setState({ ShowSideBar: "Sidebar" })
			this.setState({ bodyContentXS: 12 })
			this.setState({ bodyContentMD: 9 })
		}
	}

	render() {
		var bcXS = Number(this.state.bodyContentXS);
		var bcMD = Number(this.state.bodyContentMD);
		return (

			<div className="frame">
				<div className="wrapper">
					<Grid>
						<Row>
							<Col className="text-center" xs={12} md={2}>
								<Logo />
							</Col>
							<Col className="TopMenu" xs={12} md={10}>
								<Topmenu button={this.state.Button} fnc={this.setParentButton} />
							</Col>
						</Row>

						<Row>
							<Col className="MainMenu" md={12}>
								<Mainmenu />
								{/* <Breadcrumbs /> */}
							</Col>
						</Row>

						<Row>
							<Col className="Bodycontent" xs={bcXS} md={bcMD}>
								{/*<ToggleAccountMenu show={ this.state.show } />*/}
								<Switch>
									<Route exact path='/' component={Home} />
									{/* both /roster and /roster/:number begin with /roster */}
									{/*PUBLIC ROUTES*/}
									<Route exact path='/info/organisatie' component={Organisatie} />
									<Route exact path='/info/toelatingseisen' component={Toelatingseisen} />
									<Route exact path='/info/rcro' component={Rcrort} />
									<Route exact path='/info/beroepseed' component={Gedragscode} />
									<Route exact path='/info/voor-constructeurs' component={Constructeurs} />
									<Route exact path='/info/voor-opdrachtgevers' component={Opdrachtgevers} />
									<Route exact path='/account' render={(props) => <Account fnc={this.setParentButton} {...props} />} />
									<Route exact path='/info/contact' component={Contact} />
									<Route exact path='/info/reglamenten' component={Reglamenten} />
									<Route exact path='/cursusinformatie' component={Cursusinformatie} />
									<Route exact path='/evenementenkalender' component={Evenementenkalender} />
									<Route exact path='/bedrijven' component={Bedrijven} />
									<Route exact path='/controleren/:srch' component={Controleren} />
									<Route exact path='/controleren' component={Controleren} />
									<Route exact path='/nieuws' component={Mededelingen} />
									<Route exact path='/nieuws/nieuws-item/:number' component={Mededeling} />
									<Route exact path='/rapport/voorbeeld' component={RaportExample} />

									{/*MEMBER ROUTES*/}
									<PrivateRoute exact path='/account/mijn-cr' component={MijnCR} />
									<PrivateRoute exact path='/account/beheren' component={AccountBeheren} />
									<PrivateRoute exact path='/account/wachtwoord-wijzigen' component={WachtwoordWijzigen} />
									<PrivateRoute exact path='/kennis/beheren' component={OpleidingBeheren} />
									<PrivateRoute exact path='/werkervaring/beheren' component={WerkervaringBeheren} />
									<PrivateRoute exact path='/rapport/bekijken' component={RapportBekijken} />
									<PrivateRoute exact path='/account/indienen' component={AccountIndienen} />
									<PrivateRoute exact path='/werkervaring/referenties' component={WerkervaringReferenties} />
									<PrivateRoute exact path='/werkervaring/controle' component={WerkervaringReferentiesControle} />
									<Route exact path='/referenten/index/:ref' component={WerkervaringReferentieEmail} />
									<Route exact path='/referenten/detail/:ref/:id' component={WerkervaringReferentieDetail} />
									<PrivateRoute exact path='/werkervaring/wijzig/:id' component={WerkervaringWijzig} />
									{/*KENNIS TOEVOEGEN*/}

									{/*KENNIS TOEVOEGEN*/}



									<PrivateRoute exact path='/kennis/cursus/toevoegen' component={MemberCursusAdd} />
									<PrivateRoute exact path='/kennis/onbekende-cursus/toevoegen' component={MemberCursusOnbekendAdd} />
									<PrivateRoute exact path='/kennis/opleiding/toevoegen' component={MemberOpleidingAdd} />
									<PrivateRoute exact path='/kennis/onbekende-opleiding/toevoegen' component={MemberOpleidingOnbekendAdd} />
									<PrivateRoute exact path='/kennis/incompany-cursus/toevoegen' component={MemberIncompanyCursusAdd} />
									<PrivateRoute exact path='/kennis/incompany-kennisoverdracht/toevoegen' component={MemberIncompanyKennisAdd} />
									<PrivateRoute exact path='/kennis/bijeenkomst/toevoegen' component={MemberBijeenkomstAdd} />
									<PrivateRoute exact path='/kennis/onbekende-bijeenkomst/toevoegen' component={MemberBijeenkomstOnbekendAdd} />
									<PrivateRoute exact path='/kennis/publicaties/toevoegen' component={MemberPublicatiesAdd} />

									<PrivateRoute exact path='/kennis/docentschap/kiezen' component={MemberDocentschapOverviewAdd} />
									<PrivateRoute exact path='/kennis/docentschap/toevoegen/docentschap' component={MemberDocentschapAddDocentschap} />
									<PrivateRoute exact path='/kennis/docentschap/toevoegen/afstudeerbegeleiding' component={MemberDocentschapAddAfstudeerbegeleiding} />
									<PrivateRoute exact path='/kennis/docentschap/toevoegen/gastcollege' component={MemberDocentschapAddGastcollege} />
									<PrivateRoute exact path='/kennis/docentschap/toevoegen/examinator' component={MemberDocentschapAddExaminator} />

									<PrivateRoute exact path='/kennis/lidmaatschap/kiezen' component={MemberLidmaatschapOverviewAdd} />
									<PrivateRoute exact path='/kennis/lidmaatschap/toevoegen/bestuurslid' component={MemberLidmaatschapAddBestuurslid} />
									<PrivateRoute exact path='/kennis/lidmaatschap/toevoegen/comissielid' component={MemberLidmaatschapAddComissielid} />
									<PrivateRoute exact path='/kennis/lidmaatschap/toevoegen/redactielid' component={MemberLidmaatschapAddRedactielid} />
									<PrivateRoute exact path='/kennis/lidmaatschap/toevoegen/lid-studiecel' component={MemberLidmaatschapAddLidstudiecel} />

									<PrivateRoute exact path='/kennis/voordracht/toevoegen' component={MemberVoordrachtAdd} />

									{/* <PrivateRoute exact path='/kennis/incompany/toevoegen' component={MemberIncompanyAdd} /> */}

									{/* 
									<PrivateRoute exact path='/kennis/toevoegen' component={MemberKennisAdd} />
									<PrivateRoute exact path='/kennis/opleiding/toevoegen' component={MemberOpleidingAdd} />
									<PrivateRoute exact path='/kennis/cursus/toevoegen' component={MemberCursusAdd} />
									<PrivateRoute exact path='/kennis/docentschap/kiezen' component={MemberDocentschapChooseAdd} />
									<PrivateRoute exact path='/kennis/docentschap/toevoegen' component={MemberDocentschapAdd} />
									
									<PrivateRoute exact path='/kennis/lidmaatschap/kiezen' component={MemberLidmaatschapChooseAdd} />
									<PrivateRoute exact path='/kennis/lidmaatschap/toevoegen' component={MemberLidmaatschapAdd} />
									<PrivateRoute exact path='/kennis/publicaties/toevoegen' component={MemberPublicatiesAdd} />
									<PrivateRoute exact path='/kennis/voordracht/toevoegen' component={MemberVoordrachtAdd} /> 
									*/}

									{/*ADMIN ROUTES*/}
									<PrivateAdminRoute exact path='/admin' component={AdminIndex} />
									<PrivateAdminRoute exact path='/admin/mededelingen' component={MededelingOverview} />
									<PrivateAdminRoute exact path='/admin/mededelingen/toevoegen' component={MededelingAdd} />
									<PrivateAdminRoute exact path='/admin/mededelingen/bewerken/:id' component={MededelingEdit} />

									<PrivateAdminRoute exact path='/admin/accounts' component={AccountsOverview} />
									<PrivateAdminRoute exact path='/admin/accounts/toevoegen' component={AccountsAdd} />
									{/**<PrivateRoute exact path='/admin/accounts/bewerken' component={AccountsEdit} />**/}
									<PrivateAdminRoute exact path='/admin/accounts/bewerken/:id' component={AccountsEdit} />

									<PrivateAdminRoute exact path='/admin/bedrijven' component={BedrijvenOverview} />
									<PrivateAdminRoute exact path='/admin/bedrijven/toevoegen' component={BedrijvenAdd} />
									<PrivateAdminRoute exact path='/admin/bedrijven/bewerken/:id' component={BedrijvenEdit} />

									<PrivateAdminRoute exact path='/admin/content' component={ContentOverview} />
									<PrivateAdminRoute exact path='/admin/content/bewerken/:id' component={ContentEdit} />
									<PrivateAdminRoute exact path='/admin/leden/groepen' component={GroepenOverview} />
									<PrivateAdminRoute exact path='/admin/leden/groepen/toevoegen' component={GroepenAdd} />
									<PrivateAdminRoute exact path='/admin/leden/groepen/bewerken/:id' component={GroepenEdit} />
									<PrivateAdminRoute exact path='/admin/leden/lid/gegevens/password/:id' component={ChangePasswordAdmin} />

									<PrivateAdminRoute exact path='/admin/kennis' component={KennisOverview} />
									<PrivateAdminRoute exact path='/admin/kennis/opleiding' component={OpleidingOverview} />
									<PrivateAdminRoute exact path='/admin/kennis/bijeenkomst' component={BijeenkomstOverview} />
									<PrivateAdminRoute exact path='/admin/kennis/cursus' component={CursusOverview} />
									<PrivateAdminRoute exact path='/admin/kennis/docentschap' component={DocentschapOverview} />
									<PrivateAdminRoute exact path='/admin/kennis/incompany' component={IncompanyOverview} />
									<PrivateAdminRoute exact path='/admin/kennis/lidmaatschap' component={LidmaatschapOverview} />
									<PrivateAdminRoute exact path='/admin/kennis/publicaties' component={PublicatiesOverview} />
									<PrivateAdminRoute exact path='/admin/kennis/voordracht' component={VoordrachtOverview} />

									<PrivateAdminRoute exact path='/admin/kennis/toevoegen' component={KennisAdd} />
									<PrivateAdminRoute exact path='/admin/kennis/opleiding/toevoegen' component={OpleidingAdd} />
									<PrivateAdminRoute exact path='/admin/kennis/bijeenkomst/toevoegen' component={BijeenkomstAdd} />
									<PrivateAdminRoute exact path='/admin/kennis/cursus/toevoegen' component={CursusAdd} />
									<PrivateAdminRoute exact path='/admin/kennis/docentschap/kiezen' component={DocentschapChooseAdd} />
									<PrivateAdminRoute exact path='/admin/kennis/docentschap/toevoegen' component={DocentschapAdd} />
									<PrivateAdminRoute exact path='/admin/kennis/incompany/toevoegen' component={IncompanyAdd} />
									<PrivateAdminRoute exact path='/admin/kennis/lidmaatschap/kiezen' component={LidmaatschapChooseAdd} />
									<PrivateAdminRoute exact path='/admin/kennis/lidmaatschap/toevoegen' component={LidmaatschapAdd} />
									<PrivateAdminRoute exact path='/admin/kennis/publicaties/toevoegen' component={PublicatiesAdd} />
									<PrivateAdminRoute exact path='/admin/kennis/voordracht/toevoegen' component={VoordrachtAdd} />

									<PrivateAdminRoute exact path='/admin/kennis/bewerken/:id' component={KennisAdd} />
									<PrivateAdminRoute exact path='/admin/kennis/opleiding/bewerken/:id' component={OpleidingAdd} />
									<PrivateAdminRoute exact path='/admin/kennis/bijeenkomst/bewerken/:id' component={BijeenkomstAdd} />
									<PrivateAdminRoute exact path='/admin/kennis/cursus/bewerken/:id' component={CursusAdd} />
									<PrivateAdminRoute exact path='/admin/kennis/docentschap/bewerken/:id' component={DocentschapAdd} />
									<PrivateAdminRoute exact path='/admin/kennis/incompany/bewerken/:id' component={IncompanyAdd} />
									<PrivateAdminRoute exact path='/admin/kennis/lidmaatschap/bewerken/:id' component={LidmaatschapAdd} />
									<PrivateAdminRoute exact path='/admin/kennis/publicaties/bewerken/:id' component={PublicatiesAdd} />
									<PrivateAdminRoute exact path='/admin/kennis/voordracht/bewerken/:id' component={VoordrachtAdd} />

									<PrivateAdminRoute exact path='/admin/leden' component={LedenOverview} />
									<PrivateAdminRoute exact path='/admin/leden/toevoegen' component={LidAdd} />
									<PrivateAdminRoute exact path='/admin/leden/lid/gegevens/:id' component={LidGegevens} />
									<PrivateAdminRoute exact path='/admin/leden/lid/bedrijf/:id' component={LidBedrijf} />
									<PrivateAdminRoute exact path='/admin/leden/lid/kennis/:id' component={LidKennis} />
									<PrivateAdminRoute exact path='/admin/leden/lid/werkervaring/:id' component={LidWerkervaring} />
									<PrivateAdminRoute exact path='/admin/leden/lid/doorlopende-werkervaring/:id' component={LidDoorlopendeWerkervaring} />
									<PrivateAdminRoute exact path='/admin/leden/lid/permanente-kennis/:id' component={LidPermanenteKennis} />
									<PrivateAdminRoute exact path='/admin/leden/lid/beoordelingsdocumenten/:id' component={LidBeoordelingsDocumenten} />
									<PrivateAdminRoute exact path='/admin/leden/lid/beoordelingsdocumenten/toevoegen/:id' component={LidBeoordelingsDocumentenAdd} />
									<PrivateAdminRoute exact path='/admin/leden/lid/beoordelingsdocumenten/bewerken/:id/:mid' component={LidBeoordelingsDocumentenEdit} />
									<PrivateAdminRoute exact path='/admin/leden/lid/verklaringen/:id' component={LidVerklaringen} />
									<PrivateAdminRoute exact path='/admin/leden/lid/kennis-omzetten/:id' component={LidKennisOmzetten} />
									<PrivateAdminRoute exact path='/admin/leden/lid/inloggen/:id' component={LidInloggen} />
									{/*NEW STUFF*/}
									<PrivateAdminRoute exact path='/adminmember/kennis/cursus/toevoegen/:id' component={AdminMemberCursusAdd} />
									<PrivateAdminRoute exact path='/adminmember/kennis/onbekende-cursus/toevoegen/:id' component={AdminMemberCursusOnbekendAdd} />
									<PrivateAdminRoute exact path='/adminmember/kennis/opleiding/toevoegen/:id' component={AdminMemberOpleidingAdd} />
									<PrivateAdminRoute exact path='/adminmember/kennis/onbekende-opleiding/toevoegen/:id' component={AdminMemberOpleidingOnbekendAdd} />
									<PrivateAdminRoute exact path='/adminmember/kennis/incompany-cursus/toevoegen/:id' component={AdminMemberIncompanyCursusAdd} />
									<PrivateAdminRoute exact path='/adminmember/kennis/incompany-kennisoverdracht/toevoegen/:id' component={AdminMemberIncompanyKennisAdd} />
									<PrivateAdminRoute exact path='/adminmember/kennis/bijeenkomst/toevoegen/:id' component={AdminMemberBijeenkomstAdd} />
									<PrivateAdminRoute exact path='/adminmember/kennis/onbekende-bijeenkomst/toevoegen/:id' component={AdminMemberBijeenkomstOnbekendAdd} />
									<PrivateAdminRoute exact path='/adminmember/kennis/publicaties/toevoegen/:id' component={AdminMemberPublicatiesAdd} />

									<PrivateAdminRoute exact path='/adminmember/kennis/docentschap/kiezen/:id' component={AdminMemberDocentschapOverviewAdd} />
									<PrivateAdminRoute exact path='/adminmember/kennis/docentschap/toevoegen/docentschap/:id' component={AdminMemberDocentschapAddDocentschap} />
									<PrivateAdminRoute exact path='/adminmember/kennis/docentschap/toevoegen/afstudeerbegeleiding/:id' component={AdminMemberDocentschapAddAfstudeerbegeleiding} />
									<PrivateAdminRoute exact path='/adminmember/kennis/docentschap/toevoegen/gastcollege/:id' component={AdminMemberDocentschapAddGastcollege} />
									<PrivateAdminRoute exact path='/adminmember/kennis/docentschap/toevoegen/examinator/:id' component={AdminMemberDocentschapAddExaminator} />

									<PrivateAdminRoute exact path='/adminmember/kennis/lidmaatschap/kiezen/:id' component={AdminMemberLidmaatschapOverviewAdd} />
									<PrivateAdminRoute exact path='/adminmember/kennis/lidmaatschap/toevoegen/bestuurslid/:id' component={AdminMemberLidmaatschapAddBestuurslid} />
									<PrivateAdminRoute exact path='/adminmember/kennis/lidmaatschap/toevoegen/comissielid/:id' component={AdminMemberLidmaatschapAddComissielid} />
									<PrivateAdminRoute exact path='/adminmember/kennis/lidmaatschap/toevoegen/redactielid/:id' component={AdminMemberLidmaatschapAddRedactielid} />
									<PrivateAdminRoute exact path='/adminmember/kennis/lidmaatschap/toevoegen/lid-studiecel/:id' component={AdminMemberLidmaatschapAddLidstudiecel} />

									<PrivateAdminRoute exact path='/adminmember/kennis/voordracht/toevoegen/:id' component={AdminMemberVoordrachtAdd} />
									{/*NEW STUFF FINISH*/}
									<PrivateAdminRoute exact path='/admin/logs' component={LogsOverview} />
									<PrivateAdminRoute exact path='/admin/registraties' component={RegistratiesOverview} />
									<PrivateAdminRoute exact path='/admin/roo2' component={RoO2Overview} />

									{/*NOT FOUND ROUTE*/}
									<Route path='*' component={NotFound} />
								</Switch>
							</Col>
							<Col className={this.state.ShowSideBar} xs={12} md={3}>
								<Sidebar />
							</Col>
						</Row>
					</Grid>

					<FooterCounters />
					<FooterData />
				</div>
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js